import { getAuthHeaders } from "../../utils/authHeader";
import axiosInstance from "../../utils/axiosInstance";

const Base_URL = `/resources`;

export const uploadCompleteApi = async (resourceId, type, size) => {
  const res = await axiosInstance.post(
    `${Base_URL}/upload-complete`,
    { resourceId, type, size },
    getAuthHeaders(),
  );
  return res.data;
};
